import { View } from "react-native";
import Animated, { SlideInRight, SlideOutRight } from "react-native-reanimated";

import Icon from "$src/core/components/atoms/Icon";
import Text from "$src/core/components/atoms/Text/Text";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./TvConnectConnectedToastOverlay.styles";

type Props = {
  name?: string | null;
};

/** The sliding "device connected" toast card. */
const Toast = ({ name }: Props) => {
  const { t } = useTranslation();

  return (
    <Animated.View
      entering={SlideInRight}
      exiting={SlideOutRight}
      style={$.toast}
    >
      <Icon name="remote" style={$.icon} />
      <Text accessibilityRole="text" preset="heading6" style={$.label}>
        {name
          ? t("TV_CONNECT/HOST/CONNECTED_NAMED", { name })
          : t("TV_CONNECT/HOST/CONNECTED")}
      </Text>
    </Animated.View>
  );
};

/** Full-screen overlay that positions the toast in the top-right corner. */
const TvConnectConnectedToastOverlay = ({ name }: Props) => (
  <View style={$.overlay} pointerEvents="none">
    <Toast name={name} />
  </View>
);

export default TvConnectConnectedToastOverlay;
